import React from "react";
import ReactDOM from "react-dom";
import { ApolloProvider } from "@apollo/client";
import apolloClient from "./graphql/client";

import App from "./App";
import ErrorBoundary from "./components/other/ErrorBoundary/ErrorBoundary";
import { capture } from "./analytics";
import "./index.css";
// Design tokens FIRST (--color-*, spacing…), then the brand kit that
// builds on them. variables.css was previously imported nowhere, so
// every rule referencing var(--color-primary) silently resolved to
// nothing — which is how the login/signup buttons went invisible when
// adminlogin.css switched its hardcoded blues to the tokens.
import "./styles/variables.css";
import "./styles/brand.css";

// Surface crashes that happen outside React's render path too (async
// handlers, promise rejections) — these are what make a long-lived
// phone tab degrade quietly. No-ops until the PostHog key is set.
window.addEventListener("error", (e) => {
  capture("window_error", {
    message: String((e && e.message) || "").slice(0, 300),
    path: window.location.pathname,
  });
});
window.addEventListener("unhandledrejection", (e) => {
  const reason = e && e.reason;
  capture("unhandled_rejection", {
    message: String((reason && reason.message) || reason || "").slice(0, 300),
    path: window.location.pathname,
  });
});

const rootElement = document.getElementById("root");
ReactDOM.render(
  <ErrorBoundary>
    <ApolloProvider client={apolloClient}>
      <App />
    </ApolloProvider>
  </ErrorBoundary>,
  rootElement
);
